import React, { useEffect, useState } from "react";
import "./App.css";
import "madeinusacomponentlibrary/dist/index.css";
import configData from "./AppConfig.json";
import {
  b2cHttpClient,
  CompanyProfile,
  ProductSelector,
  selectContext,
  IUsProducer,
  IProductItem,
  IUsProducerPresenter,
  IRegistration,
  IPreferenceProgram,
  IProductLocation,
  ILocation,
  IB2CInfo,
  IIPCountry,
} from "madeinusacomponentlibrary";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  IIconProps,
  PrimaryButton,
} from "@fluentui/react";
import AuthProvider, { getAccessToken } from "./AuthProvider";
import { useId, useBoolean } from "@uifabric/react-hooks";
import { APIClient } from "./Data/APIClient";
import { IExportRegion } from "madeinusacomponentlibrary/dist/Interface/Company/IExportRegion";
import {Backdrop ,CircularProgress} from "@mui/material";
export interface appProps {}

function App(props: appProps) {
  const apiClient = new APIClient();

  const [registration, setRegistration] = useState(
    {} as IRegistration
  );
  const [usProducer, setUsProducer] = useState(
    {} as IUsProducer
  );
  const [products, setProducts] = useState(
    [] as IProductItem[]
  );
  const [states, setStates] = useState(
    [] as IProductLocation[]
  );
  const [countries, setCountries] = useState(
    [] as ILocation[]
  );
  const [preferencePrograms, setPreferencePrograms] = useState(
    [] as IPreferenceProgram[]
  );
  const [productSelections, setProductSelections] = useState(
    [] as IProductItem[]
  );
  const [regions, setRegions] = useState(
    [] as IExportRegion[]
  );

  const [b2cInfo, setB2cInfo] = useState(undefined as unknown as IB2CInfo);

  const [checkboxChecked, setCheckboxChecked] = useState(false);

  const onUsProducerUpdated = (data: IUsProducer) => {
    setFromApi(false);
    setUsProducer(data);
  };
  const [isSubmitted, setIsSubmitted] = useState(0);
  const onProductsUpdated = (data: IProductItem[]) => {
    setFromApi(false);
    setProducts(data);
  };
  const onCheckboxChecked = (checked: boolean) => {
    setCheckboxChecked(checked);
  };

  const [fromApi, setFromApi] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [response, setResponse] = useState(null);
  const [updateResponse, setUpdateResponse] = useState(null);
  const [removeRegistrationResponse, setRemoveRegistrationResponse] =
    useState(null);
  const [pendingStatus, setPendingStatus] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(true);
  const [isNew, setIsNew] = useState(false);
  const [fetching, setFetching] = useState(false);

  const Delete: IIconProps = { iconName: "Delete" };
  const dialogStyles = { main: { maxWidth: 450 } };
  const dialogContentProps = {
    type: DialogType.normal,
    title: "Are you sure?",
    closeButtonAriaLabel: "Close",
    subText:
      "You are about to delete your company from the Made in USA Directory. Do you want to proceed?",
  };

  const modalProps = React.useMemo(
    () => ({
      isBlocking: false,
      styles: dialogStyles,
    }),
    []
  );

  const myITADiv = {
    paddingTop: "300px",
    width: "800px",
    margin: "0 auto",
    textAlign: "center" as React.CSSProperties["textAlign"],
  };
const backdrop= {
  zIndex: 999,
  color: "#004b84",
  backgroundColor: "#ffffff",
}
const btnMyITADiv = {
  marginTop: "3em",
}
const container={
  width: "80%",
  margin: "0 auto;" /* Center the DIV horizontally */
}
const fixedheader={
  top: "0",
}
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);

  const handleRegistrationCreation = async () => {
    setFetching(true);
    let data = {} as IUsProducerPresenter;
    data.userId = apiClient.b2CUserId;
    data.products = products;
    const statesData = usProducer.productLocations.map((x:any) => {
      const temp = states.find((y) => y.name === x.name)!;
      return temp;
    });
    usProducer.productLocations = statesData || [];
    const countriesData = usProducer.exportDestinations.map((x:any) => {
      const temp = countries.find((y) => y.name === x.name)!;
      return temp;
    });
    usProducer.exportDestinations = countriesData || [];
    let tempRegionData: ILocation[][] = usProducer.exportDestinations.map(
      (x:any) => {
        let dataToReturn = [];
        let r = regions.filter((y) => y.countries?.find((z) => z.id === x.id));
        let temp = r.map((z) => {
          return { id: z?.id!, name: z?.name!, key: "", text: "" } as ILocation;
        });
        dataToReturn.push(...temp);
        return dataToReturn;
      }
    );
    let regionData: ILocation[] = [];
    tempRegionData.forEach((x) => regionData.push(...x));
    let ids = regionData.map((o) => o.id);
    regionData = regionData.filter(
      ({ id }, index) => !ids.includes(id, index + 1)
    );
    regionData = regionData.filter((x) => x.id !== undefined);
    usProducer.exportRegions = regionData || [];
    data.usProducer = usProducer;
    data.usProducer.contactInformation.firstName =
       AuthProvider.getAccountInfo()?.account.idTokenClaims.given_name;
     data.usProducer.contactInformation.lastName =
       AuthProvider.getAccountInfo()?.account.idTokenClaims.family_name;
     data.usProducer.contactInformation.email =
       AuthProvider.getAccountInfo()?.account.idTokenClaims.emails[0];
     data.usProducer.organizationType = data.usProducer.organizationType;
     const response = await apiClient.createRegistration(data);
     if (response.id) setResponse(response);
    setFetching(false);
  };

  const handleRegistrationUpdate = async () => {
    setFetching(true);
    let data = {} as IUsProducerPresenter;
    data.userId = apiClient.b2CUserId;
    data.id = registration.id;
    data.products = products;
    const statesData = usProducer.productLocations.map((x) => {
      const temp = states.find((y) => y.name === x.name)!;
      return temp;
    });
    usProducer.productLocations = statesData || [];
    const countriesData = usProducer.exportDestinations.map((x) => {
      const temp = countries.find((y) => y.name === x.name)!;
      return temp;
    });
    usProducer.exportDestinations = countriesData || [];
    let tempRegionData: ILocation[][] = usProducer.exportDestinations.map(
      (x) => {
        let dataToReturn = [];
        let r = regions.filter((y) => y.countries?.find((z) => z.id === x.id));
        let temp = r.map((z) => {
          return { id: z?.id!, name: z?.name!, key: "", text: "" } as ILocation;
        });
        dataToReturn.push(...temp);
        return dataToReturn;
      }
    );
    let regionData: ILocation[] = [];
    tempRegionData.forEach((x) => regionData.push(...x));
    let ids = regionData.map((o) => o.id);
    regionData = regionData.filter(
      ({ id }, index) => !ids.includes(id, index + 1)
    );
    regionData = regionData.filter((x) => x.id !== undefined);
    usProducer.exportRegions = regionData || [];
    data.usProducer = usProducer;
     data.usProducer.contactInformation.firstName =
      AuthProvider.getAccountInfo()?.account.idTokenClaims.given_name;
    data.usProducer.contactInformation.lastName =
      AuthProvider.getAccountInfo()?.account.idTokenClaims.family_name;
    data.usProducer.contactInformation.email =
      AuthProvider.getAccountInfo()?.account.idTokenClaims.emails[0];
    const response = await apiClient.updateRegistrationToDirectory(data);
    if (response) {
      setUpdateResponse(response);
    } else {
      setErrorMessage(true);
    }
    setFetching(false);
  };

  const handleRemoveRegistration = async () => {
    setFetching(true);
    const data = registration;
    const response = await apiClient.removeRegistration(data);
    if (response) {
      if (response.id) setRemoveRegistrationResponse(response);
      toggleHideDialog();
    }
    setFetching(false);
  };

  const handlePreviousAction = () => {
    setIsSubmitted(1);
    setIsEdit(true);
    setUsProducer(usProducer);
    setProducts(products);
  };

  useEffect(() => {
    (async () => 
    {
      setFetching(true);
      const b2cInfo = {} as IB2CInfo;
      b2cInfo.firstName =
        AuthProvider.getAccountInfo()?.account.idTokenClaims.given_name;
      b2cInfo.lastName =
        AuthProvider.getAccountInfo()?.account.idTokenClaims.family_name;
      b2cInfo.email =
        AuthProvider.getAccountInfo()?.account.idTokenClaims.emails[0];
      // console.log("Get Account info: " + (await getAccessToken()));
      setB2cInfo(b2cInfo);
      let dataFromDirectory: IUsProducerPresenter | undefined | null =
        undefined as unknown as IUsProducerPresenter;
      let data = await apiClient.getRegistration(apiClient.b2CUserId);
      if (data === undefined) {
        data = await apiClient.getRegistrationByEmail(b2cInfo.email!);
      }
      if (data?.approvalStatus === "approved") {
        dataFromDirectory = await apiClient.getDirectoryEntry(
          apiClient.b2CUserId
        );
        if (dataFromDirectory === undefined) {
          dataFromDirectory = await apiClient.getDirectoryByEmail();
        }
        if (!dataFromDirectory) setDataLoaded(false);
      }
      if (data?.approvalStatus === "pending") setPendingStatus(true);
      if (!data?.id) setIsNew(true);
      
      
      const states= apiClient.getStates();
      const countries = apiClient.getCountries();
      const prefProgs = apiClient.getPreferencePrograms();
      const prods = apiClient.getProducts();
      const [s,c,p,pr] = await Promise.all([states,countries,prefProgs,prods]);
      setStates(s);
      setCountries(c);
      setPreferencePrograms(p);
      setProductSelections(pr);
     
      if (data) {
        setRegistration(data);
        dataFromDirectory
          ? setUsProducer(dataFromDirectory.usProducer)
          : setUsProducer(data.registrationData?.usProducer);
        dataFromDirectory
          ? setProducts(dataFromDirectory.products)
          : setProducts(data.registrationData?.products);
        setIsEdit(false);
      } else if (data === undefined) {
        setPendingStatus(false);
        setUsProducer({} as IUsProducer);
        setProducts([]);
        setIsSubmitted(1);
        setIsEdit(true);
      } else {
        setDataLoaded(false);
      }
      setFetching(false);
    }
    )();
  }, []);
  return (
    <selectContext.Provider
      value={{
        regions,
        countries,
        states,
        preferencePrograms,
        productSelections,
        userCountry: {} as IIPCountry,
      }}
    >
      <Backdrop style={backdrop} open={fetching}>
        <CircularProgress color="inherit" aria-label="Loading" />
      </Backdrop>
      <div className="headerShadow container">
        <p>&nbsp;</p>
        <p>&nbsp;</p>
            <img src="logo.svg" style={{margin: "10px 10px"}} />
          <div style={{display:"flex",alignItems:"center"}}>
          <a href="#" onClick={AuthProvider.logout}  >Sign out</a>
          <img src="user-circle.svg" style={{marginLeft:"5px",width:"30px",height:"30px"}}></img>
          </div>
        
      </div>
      <div style={container}>
        {pendingStatus && (
          <div style={myITADiv}>
            <h1>Your {usProducer?.companyName} application is still under review.</h1>
            <p>You will receive a notification email once the review has been completed for the <br />Office of Textiles and Apparel (OTEXA) Made in USA Sourcing Directory.</p>
            <div style={btnMyITADiv}>
              <a
                className="buttonMyITA"
                target="_blank"
                href="https://trade.gov"
              >
                Go to Trade.gov
              </a>
            </div>
          </div>
        )}
        {errorMessage && (
          <div
            style={{
              paddingTop: "300px",
              width: "800px",
              margin: "0 auto",
              color: "red",
            }}
          >
            Errors occurred. Please try again.
          </div>
        )}
        {!dataLoaded && (
          <div
            style={{
              paddingTop: "300px",
              width: "800px",
              margin: "0 auto",
              color: "red",
            }}
          >
            Errors occurred. Please try again.
          </div>
        )}
        {!response &&
          !updateResponse &&
          !removeRegistrationResponse &&
          !pendingStatus &&
          !errorMessage &&
          dataLoaded && (
            <div
              className="App"
              style={{
                margin: "1em 3em",
                // width: "90%",
                padding: 10,
              }}
            >
              {(isSubmitted === 0 || isSubmitted === 1) && (
                <div style={{ display: "block" }}>
                  <CompanyProfile
                    fromApi={fromApi}
                    data={usProducer}
                    onDataChanged={onUsProducerUpdated}
                    setIsSubmitted={setIsSubmitted}
                    setIsEdit={setIsEdit}
                    b2cInfo={b2cInfo}
                    isEdit={isEdit}
                    onCheckboxChecked={onCheckboxChecked}
                    checkboxChecked={checkboxChecked}
                  />
                </div>
              )}
              {(isSubmitted === 0 || isSubmitted === 2) && (
                <div>
                  <ProductSelector
                    SelectedItems={products}
                    onChange={onProductsUpdated}
                    viewOnly={!isEdit}
                  />
                </div>
              )}
              {(isSubmitted === 0 || isSubmitted === 1) &&
                !isEdit &&
                !fetching && (
                  <div
                    style={{
                      display: "block",
                      marginLeft: "40%",
                      marginTop: "4em",
                      marginBottom: "4em",
                    }}
                  >
                    <span style={{ padding: 10 }}>
                      <DefaultButton
                        text="Remove Company"
                        onClick={toggleHideDialog}
                        iconProps={Delete}
                        className="removeBtn"
                      />
                    </span>
                  </div>
                )}
              {isSubmitted === 2 && (
                <div
                  style={{
                    display: " block",
                    clear: "both",
                    position: "relative",
                    marginLeft: "30%",
                  }}
                >
                  <button className="prevButton" onClick={handlePreviousAction}>
                    Back to Previous
                  </button>
                  {products.length !== 0 && (
                    <button
                      className="button"
                      onClick={
                        isNew
                          ? handleRegistrationCreation
                          : handleRegistrationUpdate
                      }
                    >
                      {isNew ? "Submit" : "Update"}
                    </button>
                  )}
                  {/* {!productSelected && <div>Please select at least one product</div>} */}
                </div>
              )}
            </div>
          )}
        {response && (
          <div style={myITADiv}>
            <h2>Thank you for submitting your {usProducer?.contactInformation.organizationName} application.</h2>
            <p>A confirmation email has been sent.</p>
            <div style={btnMyITADiv}>
            <a
                className="buttonMyITA"
                target="_blank"
                href="https://trade.gov"
              >
                Go to Trade.gov
              </a>
            </div>
          </div>
        )}
        {removeRegistrationResponse && (
          <div style={myITADiv}>
            {/* <h3>Thank you for submitting your application.</h3> */}
            <h1>{usProducer?.companyName} Removed</h1>
            <p>Your listing has been removed from the Office of Textiles and Apparel (OTEXA) <br />Made in USA Sourcing Directory.
            </p>
            <div style={btnMyITADiv}>
            <a
                className="buttonMyITA"
                target="_blank"
                href="https://trade.gov"
              >
                Go to Trade.gov
              </a>
            </div>
          </div>
        )}
        {updateResponse && (
          <div style={myITADiv}>
            <h2>Company Updated</h2>
            <p>
              Your {usProducer.companyName} has been successfully updated in Made in USA Directory.
            </p>
            <div style={btnMyITADiv}>
              <a
                className="buttonMyITA"
                target="_blank"
                href="https://trade.gov"
              >
                Go to Trade.gov
              </a>
            </div>
          </div>
        )}
        <Dialog
          hidden={hideDialog}
          onDismiss={toggleHideDialog}
          dialogContentProps={dialogContentProps}
          modalProps={modalProps}
        >
          <DialogFooter>
            <PrimaryButton onClick={handleRemoveRegistration} text="Confirm" />
            <DefaultButton onClick={toggleHideDialog} text="Cancel" />
          </DialogFooter>
        </Dialog>
      </div>
    </selectContext.Provider>
  );
}

export default App;
